import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBox from '../components/landing/SearchBox';
import ContentSection from '../components/landing/ContentSection';
import { useChat } from '../context/ChatContext';
import { StatusResponseSchema } from '../utils/types';
import { pageLayout } from '../styles/components';
import { cx } from '../styles';

interface LandingPageProps {
  deraStatus?: StatusResponseSchema;
}

const LandingPage: React.FC<LandingPageProps> = ({ deraStatus }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const { createAndNavigateToNewSession } = useChat();

  const handleSearch = (searchQuery: string) => {
    if (!searchQuery.trim()) return;
    
    // If DERA is not available, show a message
    if (deraStatus && deraStatus.status !== 'active') {
      alert('The DERA system is currently unavailable. Please try again later.');
      return;
    }
    
    // Use the centralized function to create a new session and handle state
    const sessionId = createAndNavigateToNewSession(searchQuery);
    
    // Navigate to the new session (ID will be passed via URL parameter)
    navigate(`/chat?sessionId=${sessionId}`);
  };

  const handleTopicSelect = (promptText: string) => {
    // Just fill the search box with the detailed prompt
    setQuery(promptText);
  };

  return (
    <div className={pageLayout.container}>
      {/* Fixed height container with its own scrolling */}
      <div className={cx(
        pageLayout.content,
        pageLayout.landingContent
      )}>
        {/* Logo */}
        <div className={pageLayout.logoContainer}>
          <h1 className={pageLayout.logoText}>zkML Research</h1>
          {deraStatus && deraStatus.status === 'active' ? (
            <div className="text-sm text-success flex items-center">
              <span className="inline-block w-2 h-2 rounded-full bg-success mr-2"></span>
              DERA System Active
            </div>
          ) : (
            <div className="text-sm text-error flex items-center">
              <span className="inline-block w-2 h-2 rounded-full bg-error mr-2"></span>
              DERA System Inactive
            </div>
          )}
        </div>

        {/* Search Box */}
        <div className={pageLayout.searchContainer}>
          <SearchBox 
            query={query} 
            setQuery={setQuery} 
            onSearch={handleSearch} 
            placeholder="Ask about zkML research..."
            buttonText="Search"
          />
        </div>

        {/* Content (Topics + Featured) */}
        <div className="mt-8 mb-16 max-w-3xl mx-auto w-full">
          <ContentSection onTopicSelect={handleTopicSelect} />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
